export const summernoteOptions = {
  minHeight: 350,
  maxHeight: 360,
  focus: true,
  toolbar: [
    ['style', ['style', 'bold', 'italic']],
    ['lists', ['ul', 'ol']],
    ['para', ['paragraph']],
    ['color', ['forecolor', 'backcolor', 'clear']],
    ['insert', ['link', 'picture', 'video']],
    ['codeview', ['codeview']],
  ],
  disableDragAndDrop: true,
  checkEmpty: true,
  styleTags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  popover: {
    image: [
      ['custom', ['imageAttributes']],
      ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
      ['float', ['floatLeft', 'floatRight', 'floatNone']],
      ['remove', ['removeMedia']],
    ],
  },
  dialogsFade: true,
  imageAttributes: {
    icon: '<i class="note-icon-pencil"/>',
    removeEmpty: true,
    disableUpload: true,
  },
}

export const createLanguagesData = (languages) => {
  const data = {
    codes: {},
    default_language: null,
    languages: [],
  }
  languages
    .sort((a, b) => {
      if (a.position < b.position) {
        return -1;
      }
      if (a.position > b.position) {
        return 1;
      }
      return 0;
    })
    .forEach((language) => {
      const { code, direction, name } = language;
      data.codes[code] = '';
      if (language.default) {
        data.default_language = code;
      }
      data.languages.push({
        code,
        direction,
        title: name,
      })
    })
  return data;
}
